import axios from "axios";
import store from "../store";
import {
  ADD_NOTIFICATION,
  GET_NOTIFICATIONS,
  SEND_NOTIFICATION,
  RESEND_NOTIFICATION,
  TEST_NOTIFICATION,
  GET_REPLIES,
  SET_REPLY_CUSTOMER_INFO,
  STOP_SEND_PROCESS,
  UNSUBSCRIBE_CUSTOMER,
  SUBSCRIBE_CUSTOMER,
  MARK_AS_READ,
  GET_CUSTOMERS_FOR_GRID,
  GET_NOTIFICATION_MESSAGES,
  SEND_MESSAGES_TO_GRID,
  ADD_AUTO_UNSUBSCRIBE_KEYWORD,
  GET_AUTO_UNSUBSCRIBE_KEYWORDS,
  UPDATE_AUTO_UNSUBSCRIBE_KEYWORD,
  DELETE_AUTO_UNSUBSCRIBE_KEYWORD,
  interceptor,
} from ".";

interceptor(axios, store);

export function addNotification(data) {
  return {
    type: ADD_NOTIFICATION,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/add`,
      data,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function sendMessagesToGrid(data) {
  return {
    type: SEND_MESSAGES_TO_GRID,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/send/selected`,
      data,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function testNotification(data) {
  return {
    type: TEST_NOTIFICATION,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/test`,
      data,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function getNotifications() {
  return {
    type: GET_NOTIFICATIONS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function resendNotification(id) {
  return {
    type: RESEND_NOTIFICATION,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/resend/${id}`,
      {},
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function getReplies(id) {
  return {
    type: GET_REPLIES,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function stopSendingProcess() {
  return {
    type: STOP_SEND_PROCESS,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/stop`,
      {},
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function unsubscribeCustomer(id) {
  return {
    type: UNSUBSCRIBE_CUSTOMER,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/unsubscribe/${id}`,
      {},
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function subscribeCustomer(id) {
  return {
    type: SUBSCRIBE_CUSTOMER,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/subscribe/${id}`,
      {},
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function markAsRead(id) {
  return {
    type: MARK_AS_READ,
    payload: axios.put(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/read/${id}`,
      {},
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function setReplyCustomerInfo(data) {
  return {
    type: SET_REPLY_CUSTOMER_INFO,
    payload: data,
  };
}

export function sendNotification(customerId, message) {
  return {
    type: SEND_NOTIFICATION,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/send/${customerId}`,
      { message },
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id,
        },
      }
    ),
  };
}

export function getCustomersForGrid() {
  return {
    type: GET_CUSTOMERS_FOR_GRID,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/grid`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function getNotificationMessages() {
  return {
    type: GET_NOTIFICATION_MESSAGES,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/messages`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      },
    }),
  };
}

export function addAutoUnsubscribeKeyword(data) {
  return {
    type: ADD_AUTO_UNSUBSCRIBE_KEYWORD,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/auto/unsubscribe/keyword/add`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      }
    }),
  };
}

export function getAutoUnsubscribeKeywords() {
  return {
    type: GET_AUTO_UNSUBSCRIBE_KEYWORDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/auto/unsubscribe/keyword`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      }
    }),
  };
}

export function updateAutoUnsubscribeKeyword(id, data) {
  return {
    type: UPDATE_AUTO_UNSUBSCRIBE_KEYWORD,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/auto/unsubscribe/keyword/${id}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      }
    }),
  };
}

export function deleteAutoUnsubscribeKeyword(id) {
  return {
    type: DELETE_AUTO_UNSUBSCRIBE_KEYWORD,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/notification_manager/auto/unsubscribe/keyword/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id,
      }
    })
  }
}
